var _circle, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgUs = function SvgUs(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_21778_20329",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#4171CF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_21778_20329)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#F6F8FA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 4.59961,
    width: 2.3,
    height: 23,
    transform: "rotate(90 20 4.59961)",
    fill: "#C12F33"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    width: 2.3,
    height: 23,
    transform: "rotate(90 20 0)",
    fill: "#C12F33"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 9.19922,
    width: 2.3,
    height: 23,
    transform: "rotate(90 20 9.19922)",
    fill: "#C12F33"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 13.8008,
    width: 2.3,
    height: 23,
    transform: "rotate(90 20 13.8008)",
    fill: "#C12F33"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 18.4004,
    width: 2.3,
    height: 23,
    transform: "rotate(90 20 18.4004)",
    fill: "#C12F33"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 11.5,
    fill: "#373BAD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.33333 5.66016L8.52043 6.236H9.12588L8.63606 6.59189L8.82315 7.16773L8.33333 6.81184L7.84351 7.16773L8.03061 6.59189L7.54079 6.236H8.14624L8.33333 5.66016Z",
    fill: "#F6F8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.33333 2.32031L8.52043 2.89615H9.12588L8.63606 3.25204L8.82315 3.82788L8.33333 3.47199L7.84351 3.82788L8.03061 3.25204L7.54079 2.89615H8.14624L8.33333 2.32031Z",
    fill: "#F6F8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.99349 2.32031L5.18058 2.89615H5.78604L5.29622 3.25204L5.48331 3.82788L4.99349 3.47199L4.50367 3.82788L4.69076 3.25204L4.20094 2.89615H4.80639L4.99349 2.32031Z",
    fill: "#F6F8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.99349 5.73047L5.18058 6.30631H5.78604L5.29622 6.6622L5.48331 7.23804L4.99349 6.88215L4.50367 7.23804L4.69076 6.6622L4.20094 6.30631H4.80639L4.99349 5.73047Z",
    fill: "#F6F8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.58333 5.73047L1.77043 6.30631H2.37588L1.88606 6.6622L2.07315 7.23804L1.58333 6.88215L1.09351 7.23804L1.28061 6.6622L0.790786 6.30631H1.39624L1.58333 5.73047Z",
    fill: "#F6F8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.99349 9L5.18058 9.57584H5.78604L5.29622 9.93173L5.48331 10.5076L4.99349 10.1517L4.50367 10.5076L4.69076 9.93173L4.20094 9.57584H4.80639L4.99349 9Z",
    fill: "#F6F8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.58333 9L1.77043 9.57584H2.37588L1.88606 9.93173L2.07315 10.5076L1.58333 10.1517L1.09351 10.5076L1.28061 9.93173L0.790786 9.57584H1.39624L1.58333 9Z",
    fill: "#F6F8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66146 4L6.84855 4.57584H7.45401L6.96418 4.93173L7.15128 5.50757L6.66146 5.15168L6.17164 5.50757L6.35873 4.93173L5.86891 4.57584H6.47436L6.66146 4Z",
    fill: "#F6F8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.28255 4L3.46965 4.57584H4.0751L3.58528 4.93173L3.77237 5.50757L3.28255 5.15168L2.79273 5.50757L2.97983 4.93173L2.49 4.57584H3.09546L3.28255 4Z",
    fill: "#F6F8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66146 0.650391L6.84855 1.22623H7.45401L6.96418 1.58212L7.15128 2.15796L6.66146 1.80207L6.17164 2.15796L6.35873 1.58212L5.86891 1.22623H6.47436L6.66146 0.650391Z",
    fill: "#F6F8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66146 7.33008L6.84855 7.90592H7.45401L6.96418 8.26181L7.15128 8.83765L6.66146 8.48176L6.17164 8.83765L6.35873 8.26181L5.86891 7.90592H6.47436L6.66146 7.33008Z",
    fill: "#F6F8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.28255 7.33008L3.46965 7.90592H4.0751L3.58528 8.26181L3.77237 8.83765L3.28255 8.48176L2.79273 8.83765L2.97983 8.26181L2.49 7.90592H3.09546L3.28255 7.33008Z",
    fill: "#F6F8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.33333 9L8.52043 9.57584H9.12588L8.63606 9.93173L8.82315 10.5076L8.33333 10.1517L7.84351 10.5076L8.03061 9.93173L7.54079 9.57584H8.14624L8.33333 9Z",
    fill: "#F6F8FA"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgUs);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/us.e5db035eddc141e897acb70ef02eaf9a.svg";